import { forwardRef, useId, type InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, id, className = "", ...rest },
  ref,
) {
  const generated = useId();
  const inputId = id ?? generated;
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={inputId} className="text-sm font-medium text-slate-700">
        {label}
      </label>
      <input
        ref={ref}
        id={inputId}
        aria-invalid={error ? true : undefined}
        className={`rounded-md border bg-white px-3 py-2 text-sm outline-none transition focus:border-brand-light focus:ring-2 focus:ring-brand/20 ${error ? "border-accent" : "border-slate-200"} ${className}`}
        {...rest}
      />
      {error ? (
        <p role="alert" className="text-xs text-accent-dark">
          {error}
        </p>
      ) : null}
    </div>
  );
});
